import React, { useState, useEffect } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { socialMedia } from '../../utils/socialmedia';
import { theme } from '../../style/theme';
import TiavinaImage from '../../assets/img/tiavina2.png';

//import styled
import {
    StyledContainer,
    StyledOverline,
    StyledTitle,
    StyledSubtitle,
    StyledDescription,
    StyledEmailLink,
    StyledImage,
    StyledImageContainer
} from './Home_styled';



const { navDelay, loaderDelay } = theme;

 const Home = () =>   {

        const [isMounted, setIsMounted] = useState(false);
        useEffect(() => {
        const timeout = setTimeout(() => setIsMounted(true), navDelay);
        return () => clearTimeout(timeout);
        }, []);


        const one = () => (
            <StyledOverline style={{ transitionDelay: '100ms' }}> Hi, je suis </StyledOverline>
        );
        const two = () => (
            <StyledTitle style={{ transitionDelay: '200ms' }}> Tiavina Rakotobe. </StyledTitle>
        );
        const three = () => (
            <>
                <StyledSubtitle style={{ transitionDelay: '300ms' }}> Je conçois </StyledSubtitle>
                <StyledSubtitle style={{ transitionDelay: '350ms' }}> des applications </StyledSubtitle>
            </>
            
        );
        const four = () => (
            <StyledDescription
            style={{ transitionDelay: '400ms' }}
            >
                    Je suis un developpeur fullstack basé à Madagascar. 
                    Je suis spécialisé dans le developpement web et le developpement mobile.
            </StyledDescription>
        );
        const five = () => (
            
            <StyledEmailLink href={`mailto:${socialMedia.gmail}`} style={{ transitionDelay: '500ms' }}>Me contacter</StyledEmailLink>
        
        );

        const items = [one, two, three, four, five];
        return (
            
            <StyledContainer>
                
                <TransitionGroup component={null}>
                    { isMounted &&
                    items.map((item, i) => (
                        <CSSTransition key={i} classNames="fadeup" timeout={loaderDelay}>
                        {item}
                        </CSSTransition>
                    ))}
                </TransitionGroup>


                {/* <StyledImageContainer>
                        <img src={TiavinaImage} alt="tia" style={{width:800, height:'90h'}}/>
                </StyledImageContainer> */}
            
            </StyledContainer>
                
            
        );
    
};
export default Home;